<template>
    <div class="bj-col bj-col-12">
        <div class="bj-form-title">
          {{ $t('ExternalOrders.newAdd.receivingInformation') }}
          <span v-if="!isReciverEdit && isShowEdit" class="link right" @click="onEditReceiverInfo">{{ $t('InternalSalesOrderDetails.Modify') }}</span>
          <span v-if="isReciverEdit" class="link right" style="margin-left:10px;" @click="saveReceiverInfo">{{ $t('saveText') }}</span>
          <span v-if="isReciverEdit" class="link right" @click="cancelReceiverInfo">{{ $t('cancelText') }}</span>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryName') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.receiverName }}</span>
            <BjInput v-else v-model="receiverInfoVO.receiverName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryPhone') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.phone }}</span>
            <BjInput v-else v-model="receiverInfoVO.phone" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel"> {{ $t('ExternalOrders.newAdd.DestinationCountry') }} </div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.country }}</span>
            <BjSelectLov v-else v-model="receiverInfoVO.country" :option-list="COUNTRY_NAME_AND_TWOCODE" :placeholder="$t('chooseText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel"> {{ $t('ExternalOrders.newAdd.DeliveryState') }} </div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.province }}</span>
            <BjInput v-else v-model="receiverInfoVO.province" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliverySuburb') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.district }}</span>
            <BjInput v-else v-model="receiverInfoVO.district" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryPostcode') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.zipCode }}</span>
            <BjInput v-else v-model="receiverInfoVO.zipCode" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryAddress1') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.deliveryAddress1 }}</span>
            <BjInput v-else v-model="receiverInfoVO.deliveryAddress1" type="textarea" show-word-limit :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.DeliveryAddress2') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.deliveryAddress2 }}</span>
            <BjInput v-else v-model="receiverInfoVO.deliveryAddress2" type="textarea" show-word-limit :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.emailAddress') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.deliveryEmailAddress }}</span>
            <BjInput v-else v-model="receiverInfoVO.deliveryEmailAddress" :maxlength="MAX_LENGTH.NORMAL_REMARK" :placeholder="$t('inputText')" />
          </div>
        </div>
        <!-- <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.comments') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.comments }}</span>
            <BjInput v-else v-model="receiverInfoVO.comments" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" />
          </div>
        </div> -->
        <!-- <div class="bj-form-item">
          <div class="bj-formItemLabel">{{ $t('ExternalOrders.newAdd.ShippingMethod') }}</div>
          <div class="bj-form-item-value">
            <span v-if="!isReciverEdit">{{ receiverInfoVO.shippingType }}</span>
            <BjSelectLov v-else v-model="receiverInfoVO.shippingType" :option-list="CSG_ORDER_SHIPPING_METHODS_LIST" />
          </div>
        </div> -->
    </div>
</template>

<script>
import { CSG_ORDER_SHIPPING_METHODS_LIST } from '@/utils/constants';
import { COUNTRY_NAME_AND_TWOCODE } from '@/utils/statics';
export default {
    props: {
        receiverInfoVO: {
            type: Object,
            default: null
        },
        isReciverEdit: {
            type: Boolean,
            default: false
        },
        isShowEdit: {
          type: Boolean,
          default: true
        }
    },
    data() {
      return { 
        CSG_ORDER_SHIPPING_METHODS_LIST,
        COUNTRY_NAME_AND_TWOCODE
      };
    },
    created() {
      // 获取国家编码下拉框数据
      // this.getCountryCodeList()
    },
    methods: {
      // 国家编码
      getCountryCodeList(){
        console.log(this.COUNTRY_NAME_AND_TWOCODE);
      },
        onEditReceiverInfo() {
            this.$emit('onEditReceiverInfo');
        },
        saveReceiverInfo() {
            this.$emit('saveReceiverInfo');
        },
        cancelReceiverInfo() {
            this.$emit('cancelReceiverInfo');
        }
    }
};
</script>
